/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsWarnData } from './lds-warn.data';
import { ILdsWarnProps } from './lds-warn.props.autogenerated';

export interface ILdsWarnViewProps extends ILdsWarnProps<ILdsWarnData> {}

/**
 *
 * LdsWarn component
 * @extends {React.PureComponent<ILdsWarnProps<ILdsWarnData>>}
 */
class LdsWarn extends React.PureComponent<ILdsWarnProps<ILdsWarnData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsWarn;
